import React, { useState } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import Vue from 'view/images/vue'
import Sass from 'view/images/sass'
import Photoshop from 'view/images/photoshop'
import Ireact from 'view/images/Ireact'
import Illustator from 'view/images/illustrator'
import GitHub from 'view/images/github'
import Es6 from 'view/images/es6'
import Less from 'view/images/less.js'


function Section03({ inView3, ref3 }) {

    return (
        <React.Fragment>
            <article
                ref={ref3}
                className={classNames("section03", {
                    on: inView3 == true,
                })}>
                <div className="wrap">
                    <div className="title">전 이러한 공부를 하고 있어요!</div>
                    <div className="title">혹은 할 예정이 랍니다 :)</div>

                    <div className="icon">
                        <div className="box">
                            <div className="_box-img"><Sass /></div>
                            <div className="_box-text">Sass</div>
                        </div>
                        <div className="box">
                            <div className="_box-img"><Less /></div>
                            <div className="_box-text">Less</div>
                        </div>
                        <div className="box">
                            <div className="_box-img"><Ireact /></div>
                            <div className="_box-text">React</div>
                        </div>
                        <div className="box">
                            <div className="_box-img"><Vue /></div>
                            <div className="_box-text">Vue</div>
                        </div>
                        <div className="box">
                            <div className="_box-img"><Es6 /></div>
                            <div className="_box-text">Es6</div>
                        </div>
                        <div className="box">
                            <div className="_box-img"><GitHub /></div>
                            <div className="_box-text">Github</div>
                        </div>
                        <div className="box">
                            <div className="_box-img"><Photoshop /></div>
                            <div className="_box-text">Photoshop</div>
                        </div>
                        <div className="box">
                            <div className="_box-img"><Illustator /></div>
                            <div className="_box-text">Illustrator</div>
                        </div>

                    </div>
                </div >
            </article >
        </React.Fragment >
    );
}

export default connect(
    // props 로 넣어줄 스토어 상태값
    (state) => ({
        layout: state.layout,
    })
)(Section03);

